import { ViewController } from "@gaming/srvg-classes-core";
import { ProgressbarView } from "../../View/ProgressbarView";
import { PhaseChangeEvent } from "../../Event/PhaseChangeEvent";

export class ProgressbarViewController extends ViewController {
    /**
     * View to be controlled
     */
    progressbarView: ProgressbarView;

    constructor( options ) {
        options = options || {};
        options.view = options.progressbarView || null;
        super( options );

        this.progressbarView = options.progressbarView || null;
    }

    // ************************** Event handlers **************************

    handlePhaseChangeEvent( event: PhaseChangeEvent, provider ) {
        var nowInMs = app.server.getTimeInMs(),
            cycleEndInMs = event.phase.end * 1000,
            cycleEndsInSeconds = (cycleEndInMs - nowInMs) / 1000,
            countdownLength = event.phase.length(),
            countdownStart = countdownLength - cycleEndsInSeconds;

        if (this.progressbarView !== null) {
            this.progressbarView.startCountdown(countdownLength, countdownStart);
        }
    }
}